<template>
  <div>
    <v-card v-if="detailsMembre">
      <v-app-bar class="transparent" light flat>
        <v-toolbar-title>
          <v-btn icon @click="$router.push('/superviseur')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          {{ detailsMembre.nom }}</v-toolbar-title
        >
      </v-app-bar>
      <v-card-text>
        <div>Groupe: {{ detailsMembre.nom_groupe }}</div>
        <div>Hors Groupe: {{ detailsMembre.hors_groupe }}</div>
        <div>Animateur: {{ detailsMembre.nom_responsable }}</div>
        <div>Région: {{ detailsMembre.ll_region }}</div>
        <div>District: {{ detailsMembre.ll_district }}</div>
        <div>Commune: {{ detailsMembre.ll_commune }}</div>
        <div>Fokontany: {{ detailsMembre.ll_fokontany }}</div>
        <div>Village: {{ detailsMembre.village }}</div>
        <div>Sexe: {{ detailsMembre.sexe }}</div>
        <div>Année de naissance: {{ detailsMembre.annee_naissance }}</div>
        <div>Age: {{ detailsMembre.annee_naissance }}</div>
        <div>Membre Gec: {{ detailsMembre.membre_gec }}</div>
        <div>Actif: {{ detailsMembre.actif_dans_groupe }}</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  created() {
    this.getDetailsMembre();
  },
  data() {
    return {
      detailsMembre: null,
    };
  },
  methods: {
    getDetailsMembre() {
      console.log("getDetailsMembre");
      var self = this;
      var idMembre = this.$route.params.id;

      var docRef = self.$firebase
        .firestore()
        .collection("membres")
        .doc(idMembre);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            self.detailsMembre = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
  },
};
</script>

<style scoped></style>
